import React, { Suspense, lazy, useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import DefaultLoader from './defaultLoader'
import LandingPage from './Courses/LandingPage/LandingPage';
import Header from './Layout/Header/Header';
import { useLocation } from 'react-router-dom';
import './App.css';
import { useSelector } from 'react-redux';
import CookieConsent from "react-cookie-consent";

const ProblemOfTheDayContainer = lazy(() => import('./ProblemOfTheDay/problemOfTheDayContainer'));
const RewardPage = lazy(() => import('./Reward/rewardPage'));
const PageNotFound = lazy(() => import('./PageNotFound/pageNotFound'))
const PaymentsRoutes = lazy(() => import('./Courses/Payments'))
const CoursesRoutes = lazy(() => import('./Courses'))
const Events = lazy(() => import('./Events/EventsHome'));
const ResumeRoutes = lazy(() => import("./Resume/AppView"));
const CourseReferralRoutes = lazy(() => import("./CourseReferral/AppView"))
const ReferralTransactionRoutes = lazy(() => import("./CourseReferral/TransactionHistory"))
const AddEditContest = lazy(() => import("./Contest/AddEditContest"));

function App() {
  const location = useLocation();
  const whitelistQueryParams = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "source",
    "medium",
    "campaignid",
    "gclid",
    "adgroup",
    "fbclid",
    "coupon",
    "click_id",
    "keyword",
  ]
  const whitelistInternalParams = [
    "itm_source",
    "itm_medium",
    "itm_campaign",
  ];
  const whitelistInternalHttpReferrer = [
    "\\bproblems",
    "\\bexplore/?$",
    "\\bevents/?$",
    "\\bhome/?$",
    "\\bcourses/?$",
    "\\bproblem-of-the-day",
    "\\bjobs/?$",
    "^/$",
  ];

  const blacklistExternalHttpReferrer = [
    "\\bhttps?://auth\\.",
    "\\bhttps?://accounts\\.",
  ];

  function getCookie(cookieName) {
    const cookies = document.cookie.split("; ");
    for (let cnt = 0; cnt < cookies.length; cnt += 1) {
      const cookie = cookies[cnt];
      const [name, value] = cookie.split("=");
      if (name === cookieName) {
        return decodeURIComponent(value);
      }
    }
    return null;
  }

  function createCookie(cookieName, cookieValue) {
    // 4000 is character limit (max size of cookie is 4kb)
    document.cookie = `${cookieName}=${JSON.stringify(cookieValue)?.substring(
      0,
      4000
    )};domain=.geeksforgeeks.org;path=/`;
  }

  useEffect(() => {
    try{
    const whiteListedCurrQueryParams = {};
    const whiteListedCurrInternalParams = {};

    window.location.search.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      (str, key, value) => {
        if (whitelistQueryParams.includes(key))
          whiteListedCurrQueryParams[key] = value;
        else if (whitelistInternalParams.includes(key))
          whiteListedCurrInternalParams[key] = value;
      }
    );

    if (Object.keys(whiteListedCurrQueryParams).length > 0) {
      createCookie("gfgpromoparams", whiteListedCurrQueryParams);
    } else if (Object.keys(whiteListedCurrInternalParams).length > 0) {
      let currentPromoParams = getCookie("gfgpromoparams");
      currentPromoParams = JSON.parse(currentPromoParams) || {};
      const hasWhiteListedParams = Object.keys(currentPromoParams).some(
        (element) => whitelistQueryParams.includes(element)
      );
      if (!hasWhiteListedParams) {
        createCookie("gfgpromoparams", whiteListedCurrInternalParams);
      }
    }
    // Code to update http_referrer in cookies
    const httpReferrer = document.referrer.toLowerCase();
    const windowPath = window.location.pathname.toLowerCase();
    if (
        !document.cookie.includes("http_referrer") ||
        (httpReferrer &&
            !httpReferrer.includes("geeksforgeeks.org") &&
            !blacklistExternalHttpReferrer.some((referrer) =>
                httpReferrer.match(referrer)
            ))
    ) {
      createCookie("http_referrer", document.referrer);
    }
    if (
        whitelistInternalHttpReferrer.some((referrer) =>
            windowPath.match(referrer)
        )
    ) {
      createCookie("http_referrer", window.location.href);
    }
  }catch (error) {
    console.log(error);
  }

  }, [location]);

  const { theme } = useSelector((state) => state);

  useEffect(() => {
    document.getElementsByTagName("body")[0]?.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <div className="App">

       <CookieConsent
            location="bottom"
            buttonText="Got it!"
            cookieName="geeksforgeeks_consent_status"
            style={{ background: "#3c404d" }}
            cookieValue="dismiss"
            buttonStyle={{ background: "#8bed4f", fontSize: "13px" , padding:"10px 30px" , borderRadius:"6px", fontWeight:"bolder" }}
        >
            We use cookies to ensure you have the best browsing experience on our website. By using our site, you acknowledge that you have read and understood our 
                <a href="https://www.geeksforgeeks.org/legal/privacy-policy/#:~:text=the%20appropriate%20measures.-,COOKIE%20POLICY,-A%20cookie%20is" className="consentLink" target="_blank"> Cookie Policy</a> &
                <a href="https://www.geeksforgeeks.org/privacy-policy/" className="consentLink" target="_blank"> Privacy Policy</a>
          </CookieConsent>
        <Suspense fallback={<DefaultLoader />}>
            <Switch>
              <Route path = "/courses" component = {CoursesRoutes}></Route>
              <Route path = "/courses-preview/:course_slug" render={() => {
                return <>
                <Header></Header>
                <div className = "CrmRoutes">
                    <LandingPage preview/>
                </div>
            </>
              }}></Route>
              <Route path = "/payments" component = {PaymentsRoutes}></Route>
              <Route path = "/problem-of-the-day" component = {ProblemOfTheDayContainer}></Route>
              <Route path = "/reward" component = {RewardPage}></Route>
              <Route path = "/events/rec/:event_slug" component = {Events}></Route>
              <Route exact path="/resume" component={ResumeRoutes}></Route>
              <Route exact path='/dashboard/contest' component={AddEditContest}></Route> 
              <Route path='/dashboard/contest/:contestId/edit' component={AddEditContest}></Route> 
              <Route exact path="/referral/transactions" component={ReferralTransactionRoutes}></Route>
              <Route path="/referral/:referral_code?" component={CourseReferralRoutes}></Route>
              <Route path="*" component={PageNotFound} />
            </Switch>
        </Suspense>
    </div>
  );
}

export default App;